import useValidationSchema from "hooks/useValidationSchema";
import { Form, Field } from "react-final-form";
import { SlotsDetailFilterProps } from "./types";
import "./slotsDetailFilter.scss";
import {
  AutoComplete,
  Button,
  DatePicker,
  MultiSelectInput,
  SelectInput,
} from "@pickit/pickit-components";
import { DATE_FORMATS } from "utils/constants";
import { SlotsFilterType } from "reducers/types/slots";
import { validationSchema } from "./schemas";
import "./i18n";
import { useTranslation } from "react-i18next";
import DropdownFilter from "../../../../component/dropdownFilter/DropdownFilter";

const SlotsDetailFilter = ({
  id,
  regions,
  workzones,
  status,
  filters,
  fetchingWorkzones,
  shifts,
  testId,
  onSubmit,
  onUpdateWorkzones,
  resetWorkzones,
  setActualRegion,
  setCollapseTable,
}: SlotsDetailFilterProps) => {
  const { t } = useTranslation();
  return (
    <DropdownFilter
      title={t("global:filter")}
      testId={testId}
      collapseTable={setCollapseTable}
    >
      <div className="container-fluid slots-detail-card-container">
        <div className="container-row">
          <div className="container-col pl-0">
            <div
              id={id}
              className="container-slots-detail-filter-fluid slots-filter-form-container"
            >
              <Form
                keepDirtyOnReinitialize
                onSubmit={(values: SlotsFilterType) => onSubmit(values)}
                initialValues={filters}
                mutators={{
                  resetWorkzones: ([field, value], state, { changeValue }) => {
                    changeValue(state, "workzone", () => "");

                    if (!value || !value.id) {
                      resetWorkzones();
                      setActualRegion("");
                    }
                  },
                }}
                validate={useValidationSchema(validationSchema)}
              >
                {({ handleSubmit, form, values, invalid }) => (
                  <form
                    className="container-slots-detail-filter-row"
                    onSubmit={handleSubmit}
                  >
                    <div className="container-slots-detail-filter-col-1">
                      <Field
                        type="text"
                        id={id + "-region"}
                        name="region"
                        onChange={form.mutators.resetWorkzones}
                        className="Admin-Pickers-input"
                        label={t("filterSlots:regionLabel")}
                        placeholder={t("filterSlots:regionPlaceholder")}
                        options={regions}
                        testId={`${testId}-region`}
                      >
                        {(props: any) => <AutoComplete {...props} />}
                      </Field>
                    </div>
                    <div className="container-slots-detail-filter-col-1">
                      <Field
                        type="text"
                        id={id + "-workzone"}
                        name="workzone"
                        className="Admin-Pickers-input"
                        label={t("filterTemplates:workzoneLabel")}
                        placeholder={t("filterTemplates:workzonePlaceholder")}
                        disabled={workzones?.length === 0 && !values.region}
                        testId={`${testId}-workzone`}
                        options={workzones}
                      >
                        {(props: any) => (
                          <MultiSelectInput
                            {...props}
                            labelAll={t("global:allF")}
                            isLoading={fetchingWorkzones}
                            onFocus={() =>
                              onUpdateWorkzones(values.region || "")
                            }
                          />
                        )}
                      </Field>
                    </div>
                    <div className="container-slots-detail-filter-col-1">
                      <div>
                        <Field
                          type="text"
                          id={id + "-date"}
                          name="date"
                          className="Admin-Pickers-input-select"
                          label={t("filterSlots:dateLabel")}
                          placeholder={t("filterSlots:datePlaceholder")}
                          language="es"
                          outputFormat="DD/MM/YY"
                          testId={`${testId}-date`}
                        >
                          {(props: any) => (
                            <DatePicker
                              outputFormat={DATE_FORMATS.shortDate}
                              {...props}
                            />
                          )}
                        </Field>
                      </div>
                    </div>
                    <div className="container-slots-detail-filter-col-1">
                      <Field
                        type="text"
                        id={id + "-status"}
                        name="status"
                        onChange={form.mutators.setValue}
                        label={t("filterSlots:statusLabel")}
                        placeholder={t("filterSlots:statusPlaceholder")}
                        className="Admin-Pickers-input"
                        options={status}
                        showProperty="description"
                        testId={`${testId}-status`}
                      >
                        {(props: any) => (
                          <MultiSelectInput keyProperty="tag" {...props} />
                        )}
                      </Field>
                    </div>
                    <div className="container-slots-detail-filter-col-1">
                      <Field
                        type="text"
                        id={id + "-shift"}
                        name="shift"
                        className="Admin-Pickers-input"
                        label={t("filterSlots:shiftLabel")}
                        placeholder={t("filterSlots:shiftPlaceholder")}
                        options={shifts}
                        testId={`${testId}-shift`}
                      >
                        {(props: any) => (
                          <SelectInput
                            showProperty="description"
                            keyProperty="tag"
                            {...props}
                          />
                        )}
                      </Field>
                    </div>
                    <div className="container-slots-detail-filter-col-1 end">
                      <Button
                        type="submit"
                        label={t("global:search")}
                        iconName="search"
                        testId={`${testId}-search-button`}
                        disabled={invalid}
                        size="large"
                        hierarchy="secondary"
                      />
                    </div>
                  </form>
                )}
              </Form>
            </div>
          </div>
        </div>
      </div>
    </DropdownFilter>
  );
};

export default SlotsDetailFilter;
